import * as React from "react";
import { useTranslation } from "react-i18next";
import { getEnterpriseGroupSyncPlugin } from "util/AuthenticationService";
import { DocumentTitle, Spinner } from "components/common";
import { AUTH_BACKEND_META, HELP } from "./BackendCreate";
import WizardPageHeader from "./WizardPageHeader";
import prepareInitialWizardValues from "../PrepareInitialWizardValues";
import BackendWizard from "../BackendWizard";
import handleUpdate from "../HandleUpdate";
const _optionalWizardProps = (initialStepKey) => ({ initialStepKey });
const BackendEdit = ({ authenticationBackend, initialStepKey }) => {
  var _a, _b;
  const { t } = useTranslation("authentication");
  const enterpriseGroupSyncPlugin = getEnterpriseGroupSyncPlugin();
  const { help: groupSyncHelp = {}, initialValues: initialGroupSyncValues = {} } = (_b = (_a = enterpriseGroupSyncPlugin == null ? void 0 : enterpriseGroupSyncPlugin.wizardConfig) == null ? void 0 : _a.ldap) != null ? _b : {};
  const help = { ...HELP, ...groupSyncHelp };
  let initialValues = prepareInitialWizardValues(authenticationBackend);
  if (enterpriseGroupSyncPlugin) {
    const { formValues: groupSyncFormValues, finishedLoading } = enterpriseGroupSyncPlugin.hooks.useInitialGroupSyncValues(authenticationBackend.id, initialGroupSyncValues);
    if (!finishedLoading) {
      return /* @__PURE__ */ React.createElement(Spinner, null);
    }
    initialValues = { ...initialValues, ...groupSyncFormValues };
  }
  const authBackendMeta = {
    ...AUTH_BACKEND_META,
    backendId: authenticationBackend.id,
    backendHasPassword: authenticationBackend.config.systemUserPassword.isSet,
    backendGroupSyncIsActive: !!initialValues.synchronizeGroups
  };
  const _handleSubmit = (payload, formValues, serviceType, shouldUpdateGroupSync) => handleUpdate(
    payload,
    formValues,
    authenticationBackend.id,
    !!initialValues.synchronizeGroups,
    serviceType,
    shouldUpdateGroupSync
  );
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("ldap.edit_title") }, /* @__PURE__ */ React.createElement(WizardPageHeader, { authenticationBackend }), /* @__PURE__ */ React.createElement(
    BackendWizard,
    {
      ..._optionalWizardProps(initialStepKey),
      help,
      authBackendMeta,
      initialValues,
      onSubmit: _handleSubmit
    }
  ));
};
export default BackendEdit;
